import { render } from "./Leads.vue?vue&type=template&id=ccd95dfa&scoped=true"
import script from "./Leads.vue?vue&type=script&lang=js"
export * from "./Leads.vue?vue&type=script&lang=js"

import "./Leads.vue?vue&type=style&index=0&id=ccd95dfa&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccd95dfa"]])

export default __exports__